import { formatFieldError, translateBackendError } from './errorTranslator'

export interface ParsedErrors {
  fieldErrors: Record<string, string>
  generalMessage: string
  errorResponse: any
}

export const parseBackendErrors = (
  error: any,
  t: (key: string, options?: { defaultValue?: string }) => string,
  defaultErrorMessage: string
): ParsedErrors => {
  const translateError = (errorText: string): string => {
    return translateBackendError(errorText, t)
  }

  let fieldErrors: Record<string, string> = {}
  let generalMessage = ''
  let errorData: any = null

  if (error.response?.data) {
    errorData = error.response.data

    if (typeof errorData === 'object' && !Array.isArray(errorData)) {
      const processNestedErrors = (obj: any, prefix: string = '') => {
        Object.keys(obj).forEach((key) => {
          const fullKey = prefix ? `${prefix}.${key}` : key
          const value = obj[key]

          if (Array.isArray(value)) {
            if (value.length > 0 && typeof value[0] === 'string') {
              const translatedErrors = value.map((err: string) => translateError(err))
              fieldErrors[fullKey] = translatedErrors.join(', ')
            } else if (value.length > 0 && typeof value[0] === 'object') {
              value.forEach((item: any, index: number) => {
                if (typeof item === 'object' && item !== null) {
                  const itemKey = `${fullKey}[${index}]`
                  if (item.non_field_errors) {
                    const errors = Array.isArray(item.non_field_errors)
                      ? item.non_field_errors.map((e: string) => translateError(e)).join(', ')
                      : translateError(item.non_field_errors)
                    fieldErrors[`${itemKey}.non_field_errors`] = errors
                  }
                  processNestedErrors(item, itemKey)
                }
              })
            }
          } else if (typeof value === 'object' && value !== null) {
            processNestedErrors(value, fullKey)
          } else if (typeof value === 'string') {
            fieldErrors[fullKey] = translateError(value)
          }
        })
      }

      processNestedErrors(errorData)

      // Format field errors for better display
      const formattedFieldErrors: Record<string, string> = {}
      Object.keys(fieldErrors).forEach((key) => {
        formattedFieldErrors[key] = formatFieldError(key, fieldErrors[key], t)
      })
      fieldErrors = formattedFieldErrors

      const allErrors = Object.values(fieldErrors)
      if (allErrors.length > 0) {
        generalMessage = allErrors.join(', ')
      }
    } else if (Array.isArray(errorData)) {
      const translatedErrors = errorData.map((err: string) => translateError(err))
      generalMessage = translatedErrors.join(', ')
      fieldErrors._general = generalMessage
    } else if (typeof errorData === 'string') {
      generalMessage = translateError(errorData)
      fieldErrors._general = generalMessage
    } else if (errorData?.detail) {
      generalMessage = translateError(errorData.detail)
      fieldErrors._general = generalMessage
    }
  } else {
    generalMessage = defaultErrorMessage
  }

  const errorResponse = {
    status: error.response?.status,
    statusText: error.response?.statusText,
    url: error.config?.url || error.response?.config?.url || error.request?.responseURL,
    message: error.message,
    error: errorData || error.response?.data,
  }

  return {
    fieldErrors,
    generalMessage: generalMessage || defaultErrorMessage,
    errorResponse,
  }
}
